var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.998 7V1H17.5L21 4.5V23H15M16 1V6H21M4.5 16.5L8 13L11.5 16.5M8 13.5V20M8 23C9.85652 23 11.637 22.2625 12.9497 20.9497C14.2625 19.637 15 17.8565 15 16C15 14.1435 14.2625 12.363 12.9497 11.0503C11.637 9.7375 9.85652 9 8 9C6.14348 9 4.36301 9.7375 3.05025 11.0503C1.7375 12.363 1 14.1435 1 16C1 17.8565 1.7375 19.637 3.05025 20.9497C4.36301 22.2625 6.14348 23 8 23Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.fc35bd08cd7d41c77a59ebcb53278019.svg";
export { ForwardRef as ReactComponent };